// extracted by mini-css-extract-plugin
export default {"container":"styles_container__LpN44","body":"styles_body__6XdhU"};